var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconIr = function SvgIconIr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M15.898 8.87h-1.57q.02.258.02.521c0 1.161-.29 2.286-.796 3.087-.156.247-.418.596-.77.831V8.87h-1.565v4.44c-.35-.235-.613-.584-.769-.83-.506-.802-.796-1.927-.796-3.088q.001-.263.02-.521h-1.57q-.015.257-.015.521c0 3.219 1.719 5.74 3.913 5.74s3.913-2.521 3.913-5.74q0-.264-.015-.521"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M4.957 5.738h1.565v1.044h1.566V5.738h1.565v1.044h1.565V5.738h1.565v1.044h1.565V5.738h1.566v1.044h1.565V5.738h1.565v1.044h3.766A12 12 0 0 0 12-.001 12 12 0 0 0 1.192 6.782h3.766z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M19.044 17.217v1.043H17.48v-1.043h-1.565v1.043h-1.565v-1.043h-1.566v1.043h-1.565v-1.043H9.653v1.043H8.088v-1.043H6.522v1.043H4.957v-1.043H1.191a12 12 0 0 0 10.81 6.782 12 12 0 0 0 10.809-6.782z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconIr;